import oftalmo1 from "../images/editii/2024-oftalmologie-1.jpg";
import oftalmo2 from "../images/editii/2024-oftalmologie-2.jpg";
import sat1 from "../images/editii/2025-educatia-la-sat-1.jpg";
import sat2 from "../images/editii/2025-educatia-la-sat-2.jpg";
import brestovatFatada from "../images/editii/2023-brestovat-fatada.jpg";
import brestovatPavaj from "../images/editii/2023-brestovat-pavaj.jpg";
import brestovatAcoperis from "../images/editii/2023-brestovat-acoperis.jpg";
import brestovatHol from "../images/editii/2023-brestovat-hol.jpg";

export const HistoryData = [
  {
    year: "2009",
    title: "Dispensar mobil pentru județul Timiș",
    text: "Repararea unui dispensar mobil care acordă ajutor medical în localități din județul Timiș care nu dispun de facilitățile necesare.",
    images: [],
  },
  {
    year: "2010",
    title: "Clinica II de Pediatrie „Bega”",
    text: "Renovarea unui salon al Clinicii II de Pediatrie „Bega” din Timișoara.",
    images: [],
  },
  {
    year: "2011",
    title: "ATI Chirurgie Generală Oncologică II",
    text: "Reamenajarea Secției de ATI din cadrul Clinicii de Chirurgie Generală Oncologică II a Spitalului Clinic Municipal de Urgență Timișoara.",
    images: [],
  },
  {
    year: "2012",
    title: "Spitalul de Copii „Louis Țurcanu”",
    text: "Dotarea Spitalului de Copii „Louis Țurcanu” din Timișoara.",
    images: [],
  },
  {
    year: "2013",
    title: "ISU Banat",
    text: "Dotarea ISU Banat.",
    images: [],
  },
  {
    year: "2014",
    title: "ATV pentru SALVO",
    text: "Achiziționarea unui ATV cu șenile, lamă de zăpadă și remorcă pentru Formațiunea de Intervenție Rapidă pe Bază de Voluntariat „SALVO”.",
    images: [],
  },
  {
    year: "2015",
    title: "Neonatologie „Louis Țurcanu”",
    text: "Dotarea Secției de Neonatologie din cadrul Spitalului de Copii „Louis Țurcanu”.",
    images: [],
  },
  {
    year: "2016",
    title: "Ortopedie „Pius Brînzeu”",
    text: "Amenajarea și dotarea Secției de Ortopedie - Traumatologie II din cadrul Spitalului Clinic Județean de Urgență „Pius Brînzeu” Timișoara.",
    images: [],
  },
  {
    year: "2017",
    title: "Neonatologie SCMUT (Odobescu)",
    text: "Renovarea unor saloane din cadrul Clinicii de Neonatologie a Spitalului Clinic Municipal de Urgență Timișoara (Odobescu).",
    images: [],
  },
  {
    year: "2018",
    title: "Centrul IncubART",
    text: "Crearea unui spațiu dedicat artelor muzicale pentru Centrul IncubART.",
    images: [],
  },
  {
    year: "2019",
    title: "Atelier robotică · Colegiul Bănățean",
    text: "Dotarea și dezvoltarea unui atelier de robotică în cadrul Colegiului Național Bănățean din Timișoara.",
    images: [],
  },
  {
    year: "2020",
    title: "Tablete pentru educație online",
    text: "Achiziționarea de tablete pentru accesul echitabil la educația online al elevilor Centrului Școlar pentru Educație Incluzivă „Dumitru Ciumăgeanu” și Centrul Frății lui Onisim.",
    images: [],
  },
  {
    year: "2021",
    title: "Liceul Iris · deficiențe de vedere",
    text: "Dotarea și dezvoltarea Liceului Teoretic Special Iris pentru elevii cu deficiențe de vedere.",
    images: [],
  },
  {
    year: "2023",
    title: "Bookland · Școala din Brestovăț",
    text: "Sprijinirea Asociației Bookland România pentru renovarea Școlii Gimnaziale din Comuna Brestovăț, jud. Timiș.",
    images: [
      { src: brestovatFatada, alt: "Fațada Școlii Gimnaziale din Brestovăț, după renovare" },
      { src: brestovatAcoperis, alt: "Acoperiș nou montat pe corpul școlii" },
      { src: brestovatHol, alt: "Holul interior renovat, cu iluminat nou și pereți decorați" },
      { src: brestovatPavaj, alt: "Pavaj nou amenajat la intrarea în școală" },
    ],
  },
  {
    year: "2024",
    title: "Oftalmologie · caravană medicală Brestovăț",
    text: "Dotarea Clinicii de Oftalmologie a Spitalului Clinic Municipal de Urgență Timișoara cu un tonometru portabil și ochelari de vedere pentru copiii din comuna Brestovăț prin caravană medicală.",
    images: [
      { src: oftalmo1, alt: "Examen oftalmologic cu tonometru portabil URK-700A" },
      { src: oftalmo2, alt: "Copii din Brestovăț testați cu ochelarii de diagnostic" },
    ],
  },
  {
    year: "2025",
    title: "„Educația la Sat”",
    text: "Sprijinirea inițiativei „Educația la Sat” prin renovarea unei săli de clasă și acoperirea costurilor orelor de logopedie pentru copiii din program.",
    images: [
      { src: sat2, alt: "Sala de clasă înainte de renovare" },
      { src: sat1, alt: "Sala de clasă renovată — spațiu primitor pentru copii" },
    ],
  },
];

export const PastEditionVideos = [
  {
    year: "2023",
    title: "Cursa 2023 — Aftermovie",
    url: "https://youtu.be/SeY4NzOuef8",
  },
  {
    year: "2023",
    title: "Cursa 2023 — Highlights",
    url: "https://youtu.be/Dt7rUL3PfP4",
  },
  {
    year: "2019",
    title: "Cursa 2019",
    url: "https://www.youtube.com/watch?v=nhB1kBskbLM",
  },
  {
    year: "2016",
    title: "Cursa 2016",
    url: "https://www.youtube.com/watch?v=BozOFuuWx0E",
  },
  {
    year: "2015",
    title: "Cursa 2015",
    url: "https://www.youtube.com/watch?v=Xf0LRWKt_VA",
  },
];
